import React, {Component} from 'react';
import PropTypes from "prop-types";

class Tbody extends Component {
    static propTypes = {
        data: PropTypes.array,
        columns: PropTypes.array,
    };
    static defaultProps = {
        data: undefined,
        columns: []
    };

    render() {
        let {data, columns} = this.props;

        let rows = [];
        if(data && data[0] && columns){

            data.forEach((item, index)=>{
                let cols = [] //<td key={'index'}>{index}</td>];

                columns.forEach((col, index2)=>{
                    cols.push(<td key={index2}>
                        <div >
                            {
                                item[col.key]
                            }
                        </div>
                    </td>)
                })
                rows.push(<tr key={index}>
                    {cols}
                </tr>)
            })
        }

        return (
            <tbody style={{
                overflow:'scroll',
                height:'90%',
            }}>

            {rows}

            {/*{data && data.map((item, index)=>{*/}
            {/*    return (*/}
            {/*    <tr key={index}>*/}
            {/*        <td>*/}
            {/*            {index}*/}
            {/*        </td>*/}
            {/*        { columns.map((col, index2)=>{*/}
            {/*            let style = Object.assign({} , {*/}
            {/*                // maxWidth:'1000px',*/}
            {/*                maxHeight:'100px',*/}
            {/*                overflow:'hidden',*/}
            {/*                height:'100%',*/}
            {/*            } , col.style )*/}

            {/*            return <td key={index2} style={style}>*/}
            {/*                <div >*/}
            {/*                    {*/}
            {/*                         item[col.key]*/}
            {/*                    }*/}
            {/*                </div>*/}
            {/*                </td>*/}
            {/*        })*/}
            {/*        }*/}
            {/*    </tr>*/}
            {/*    )*/}
            {/*})*/}
            {/*}*/}
            </tbody>
        );
    }
}

export default Tbody;